import { render, staticRenderFns } from "./PCCTable.vue?vue&type=template&id=0f8d9762&"
import script from "./PCCTable.vue?vue&type=script&lang=js&"
export * from "./PCCTable.vue?vue&type=script&lang=js&"
import style0 from "./PCCTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports